import { ReactNode } from "react";
import clsx from "clsx";

interface PageProps {
  children?: ReactNode;
}

function Page({ children }: PageProps) {
  return (
    <main
      className={clsx(
        "flex flex-col relative text-white bg-dark-2 bg-dark-page",
        "pt-30 lg:pt-[140px] xl:pt-[160px] min-h-screen h-full w-screen"
      )}
    >
      {children}
    </main>
  );
}

export default Page;
